import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class ExtraChargeService {

  putExtraCharge(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_EXTRA_CHARGES
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    let extraCharges = []

    data.formData.forEach(extraCharge => {
      const newEntry = {
        ...extraCharge,
        createdBy: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        updatedBy: undefined
      }
      extraCharges.push(newEntry)
    })

    const putData = {
      hotelCode: data.hotelCode,
      extraCharges: extraCharges
    }

    return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

  getExtraCharges(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_EXTRA_CHARGES
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }
    return fetchJSON(url, secureGET()).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

}

export default new ExtraChargeService()